export const toFileList = files => {
  return files?.map((document, index) => ({
    ...document,
    uid: document.id || index,
    status: "done"
  }))
}
